import { notification } from 'antd';

export const handleMessageError = (error: any, noConvertName?: boolean) => {
    let err = error?.response;

    if (err) {
        if (typeof err === 'string') {
            err = error?.response?.data?.message;
        } else {
            err = error?.response?.data?.message ?? error?.response?.data?.message?.error ?? 'LỖI';
        }
    } else {
        err = 'LỖI';
    }
    notification.error({
        message: err,
    });

    // Cannot delete ${feeTypeNames} fee type while ${customerTypeNames} in use

    // notification.error({
    //     message: 'Đã có lỗi',
    //     description: `${t(`validateMessage:${typeMessage.type}`, {
    //         ...(typeMessage.line && { line: `${typeMessage.line}` }),
    //         ...(typeMessage.field && {
    //             name: noConvertName ? typeMessage.field : t(`validateName:${typeMessage.field}`),
    //         }),
    //         ...(typeMessage.maxlength && { maxlength: `${typeMessage.maxlength}` }),
    //         ...(typeMessage.minValue && { minValue: `${typeMessage.minValue}` }),
    //         ...(typeMessage?.data?.name && { dataError: `${typeMessage.data.name}` }),
    //     })}`,
    // });
};
